module.exports = __webpack_public_path__ + "img/支付页@2x.png";